import { render, staticRenderFns } from "./deleteModal.vue?vue&type=template&id=26139d7e&"
import script from "./deleteModal.vue?vue&type=script&lang=ts&"
export * from "./deleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports